// extracted by mini-css-extract-plugin
export default {"man":"man_man__idhun","icon":"man_icon__k+yZZ","negative":"man_negative__+k7I7"};